<template>
    <div class="listing-map">
        <div style="width: 100%; height:320px" ref="mapContainer"></div>
            <div v-if="bubbleMounted" ref="bubbleEl" style="min-width:180px;line-height:1.35em;">
                <h5 class="td-h5">{{ listing.name }}</h5>

                <div class="address td-text-subdued" style="font-size:14px">
                    <hours-status :listing="listing" />
                    {{ listing.location.line1 }}<br />
                    {{ listing.location.line2 }}
                </div>
            </div>
    </div>
</template>

<script>import script from './ListingMap';
    export default script;</script>
